import { render } from "./ingresoshospedaje.vue?vue&type=template&id=7667ed43"
import script from "./ingresoshospedaje.vue?vue&type=script&lang=js"
export * from "./ingresoshospedaje.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__